import { Injectable } from '@angular/core';

export interface MatNotificationData {
	message?: string
	title?: string
	icon?: string
	image?: string
	during?: number
	canClose?: boolean
	progress?: number | 'indeterminate'
	actions?: {text: string, action: Function}[]
	type?: 'success' | 'warn'
}

export class MatNotificationRef implements MatNotificationData {

	id: string;
	message: string
	title: string
	icon: string
	image: string
	during: number
	canClose: boolean = false
	progress: number | 'indeterminate';
	actions: {text: string, action: Function}[] = []
	type: 'success' | 'warn';

	onClose: Function;

	private duringTimer;

	set (data: MatNotificationData): this {

		if(data.during) 
			this.duringTimer = setTimeout(() => this.close(), data.during);

		if(!data.hasOwnProperty('canClose'))
			data.canClose = (data.type === 'warn');

		if(!data.hasOwnProperty('type'))
			delete this.type;

		if(!data.hasOwnProperty('progress'))
			delete this.progress;

		Object.assign(this, data);

		return this;
	}

	close () { 

		if(this.duringTimer)
			clearTimeout(this.duringTimer);
		
		this.onClose(this.id)
	}
}

@Injectable({
  providedIn: 'root'
})
export class MatNotificationService {

	static readonly SHORT_DURATION = 3000;
	static readonly LONG_DURATION = 5000;

	notifications: MatNotificationRef[] = [];

  	constructor() {}

	get last(): MatNotificationRef {
		return this.notifications.last || this.open({});
	}

	get lastOnly(): MatNotificationRef {
		this.notifications.slice(0, -1).each(notification => notification.close());
		return this.last;
	}

	open (data: MatNotificationData): MatNotificationRef {
		let notificationRef;

		// If is error notification alter last pending notification
		if(data.type === 'warn')
			notificationRef = this.notifications.filter(({progress}) => progress !== null).last;

		if(notificationRef)
			notificationRef.set(data);

		else {
			notificationRef = new MatNotificationRef().set(data);

			notificationRef.id = `mat-notification-${(this.notifications.last?.id.toNumber() ?? 0) + 1}`;
			notificationRef.onClose = (id: string) => this.notifications.splice(this.notifications.findIndex(n => n.id === id) , 1);

			this.notifications.push(notificationRef);	
		}

		return notificationRef;
	}

	closeAll () {
		this.notifications.each(notification => notification.close());
		return this;
	}
}
